import axios from "axios";

// Always call the API on the same origin the app is served from. This keeps
// the access_token cookie first-party regardless of whether the app is loaded
// from the preview URL, the emergent.host deploy URL, or a custom domain like
// app.dftb26.com - `/api/*` is routed to the FastAPI backend on every host.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const sameOrigin = typeof window !== "undefined" ? window.location.origin : BACKEND_URL;
export const API = `${sameOrigin}/api`;

// Cookies are first-party in this deployment (frontend + backend share the ingress host).
// Auth is carried via httpOnly `access_token` cookie - no JS-readable token storage needed.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}

export default api;
